// Student.container: signup method at /signup/student; incomplete student signup is routed to /student/signup.
// Mistake: incomplete-login redirect ran when returning to method screen; skip when Link state allowSignupMethodScreen.
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getAccessToken } from "helpers/Auth.helper";
import * as AuthApi from "api/common/Auth.api";
import StudentSignupPreContainer from "./StudentSignupPre.container";
import StudentSignupContainer from "./StudentSignup.container";

const StudentContainer = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const isRegister = location.pathname.startsWith("/signup/student/register");

    useEffect(() => {
        if (isRegister) {
            return;
        }
        const state = location.state as { allowSignupMethodScreen?: boolean } | null | undefined;
        if (state?.allowSignupMethodScreen) {
            return;
        }
        const token = getAccessToken();
        if (!token) {
            return;
        }
        let cancelled = false;
        (async () => {
            try {
                const my = await AuthApi.getMyInfo();
                if (cancelled || !my?.info) {
                    return;
                }
                if (my.info.accountTypeCode === "accountType:student" && my.info.hasDoneSignup === false) {
                    navigate(`/student/signup${location.search}`, { replace: true });
                }
            } catch {
                // ignore
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [isRegister, location.search, location.state, navigate]);

    const cancelSignup = () => {
        navigate("/signup");
    };

    if (isRegister) {
        return (
            <StudentSignupContainer
                cancelSignup={cancelSignup}
                accountTypeCode="accountType:student"
            />
        );
    }

    return <StudentSignupPreContainer />;
};

export default StudentContainer;
